function snapshot(form) {
    var values = {};
    form.querySelectorAll('input[name], select[name], textarea[name]').forEach(function (field) {
        if (field.name.includes('#NUM#') || field.closest('[id^="sample_"]') ||
            ['FormTokenSignature', 'act', 'oldInvNumber'].includes(field.name) ||
            ['submit', 'button', 'reset', 'image'].includes(field.type)) {
            return;
        }
        // The hidden EUR/BGN rate is refreshed asynchronously but is not used by the form's calculations.
        if (['currency_rate', 'date_rate'].includes(field.name) && field.getClientRects().length === 0) {
            return;
        }
        // Disabled invoice values still matter; unlocking a field alone is not an edit.
        if (field instanceof HTMLInputElement && ['checkbox', 'radio'].includes(field.type) && !field.checked) {
            return;
        }
        var fieldValues = field instanceof HTMLSelectElement
            ? Array.from(field.selectedOptions, function (option) { return option.value; })
            : [field.value.replace(/\r\n/g, '\n')];
        values[field.name] = (values[field.name] || []).concat(fieldValues);
    });
    // Moving controls (e.g. the currency dropdown when rows change) is not a data change.
    return JSON.stringify(Object.keys(values).sort().map(function (name) { return [name, values[name]]; }));
}
export function createInvoiceDirtyTracker(form) {
    var baseline = null;
    return {
        captureBaseline: function () {
            baseline = snapshot(form);
        },
        isDirty: function () {
            return baseline !== null && snapshot(form) !== baseline;
        },
    };
}
